import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import CKEditor from 'ckeditor4-vue';
import VImageInput from 'vuetify-image-input';


//novi editor

// import plugin
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
// don't forget to import CSS styles
import 'tiptap-vuetify/dist/main.css'
// Vuetify's CSS styles
import 'vuetify/dist/vuetify.min.css'

//=

Vue.use(Vuetify)
Vue.use( CKEditor );
Vue.component('VImageInput', VImageInput);

const vuetify = new Vuetify()


Vue.use(TiptapVuetifyPlugin, {
  // the next line is important! You need to provide the Vuetify Object to this place.
  vuetify, // same as "vuetify: vuetify"
  // optional, default to 'md' (default vuetify icons before v2.0.0)
  iconsGroup: 'mdi'
})

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#009FE3', // promjenjena primary color da se slaze sa logom next auta
        secondary: '#4caf50',
        tertiary: '#495057',
        accent: '#82B1FF',
        error: '#f55a4e',
        info: '#00d3ee',
        success: '#009FE3',
        warning: '#5cb860'
      }
    }
  },
  icons: {
    iconfont: 'mdi'
  }
})
